module.exports = __webpack_public_path__ + "img/PN.5d81147c.png";